import React from 'react';

export default function({ onSelect, selected }) {
  const types = {
    bios: 'bios',
    names: 'names',
    packs: 'packs',
    promo: 'promo',
  };

  return (
    <div style={styles.container}>
      <span>Content:</span>
      <div
        onClick={() => onSelect(types.bios)}
        style={Object.assign(
          {},
          styles.button,
          selected === types.bios && styles.selected,
        )}
      >
        Bios
      </div>
      <div
        onClick={() => onSelect(types.names)}
        style={Object.assign(
          {},
          styles.button,
          selected === types.names && styles.selected,
        )}
      >
        Names
      </div>
      <div
        onClick={() => onSelect(types.packs)}
        style={Object.assign(
          {},
          styles.button,
          selected === types.packs && styles.selected,
        )}
      >
        Packs
      </div>
      <div
        onClick={() => onSelect(types.promo)}
        style={Object.assign(
          {},
          styles.button,
          selected === types.promo && styles.selected,
        )}
      >
        Promo
      </div>
    </div>
  );
}

const styles = {
  button: {
    color: 'blue',
    cursor: 'pointer',
    display: 'inline-block',
    padding: '5px 10px',
  },
  container: {},
  selected: {
    textDecoration: 'underline',
  },
};
